<template>
  <v-navigation-drawer v-model="miniNav" app style="z-index: 100;">
    <v-list dense>
      <v-list-item
        style="max-height: 170px;border-bottom: 1px solid rgba(0, 0, 0, 0.05);"
        class="pb-5"
      >
        <div class="image-logo">
          <v-img class="image-nav" :src="yotodoLogo" />
        </div>
      </v-list-item>
    </v-list>

    <v-list dense>
      <v-list-item
        link
        v-for="(sidebarItem, j) in sidebarData2"
        :key="j"
        :to="sidebarItem.to"
      >
        <v-list-item-icon class="pr-0 mr-3">
          <v-icon :color="sidebarItem.color">{{ sidebarItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-grey">{{ sidebarItem.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
import { sidebar, mainMenu } from "@/router/nav";
const { mapState } = createNamespacedHelpers("system");
export default {
  name: "AppSidebar",
  data() {
    return {
      mini: true,
      drawer: null,
      tempData: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {},
  mounted() {
    console.log(this.sidebarData);
  },
  computed: {
    yotodoLogo() {
      return require("@/assets/img/logo/karyatama-logo.png");
    },
    sidebarData() {
      return sidebar;
    },
    sidebarData2() {
      return mainMenu;
    },
    ...mapState(["miniNav"])
  },
  watch: {
    miniNav(newval) {
      console.log(newval);
    }
  },
  methods: {
    miniNavsize() {
      if (this.window.width <= 1270) {
        this.miniNav = true;
      } else {
        this.miniNav = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
